import React, { Suspense } from "react";

import * as router from "react-router-dom";
import { Container } from "reactstrap";

import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav2 as AppSidebarNav,
} from "@coreui/react";

import { useSelector } from "react-redux";
import InstallButton from "../../Pages/installButton";
import AddFact from "../../Pages/Add_Fact/AddFact";
import { useState } from "react";
import ContextMenuContainer from "../../Components/ContextMenu/containerMenu";
import logo from "../../Assets/img/brand/logo.svg"
// import BodyLayout from "./0_Body";

// const DefaultAside = React.lazy(() => import("./DefaultAside/DefaultAside"));
const DefaultFooter = React.lazy(() => import("./DefaultFooter/DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader/DefaultHeader"));

const LayoutTest = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  // const dispatch = useDispatch();

  const loading = () => (
    <div className="animated fadeIn pt-1 text-center">در حال بارگذاری...</div>
  );

  function signOut(e) {
    e.preventDefault();
    this.props.history.push("/login");
  }

  const properties = {
    location: props.location,
    history: props.history,
    match: props.match,
  };
  // console.log(props, "is props");
  return (
    <div className="app">
      <AppHeader fixed>
        <Suspense fallback={loading()}>
          <DefaultHeader onLogout={(e) => signOut(e)} />
        </Suspense>
      </AppHeader>
      <div className="app-body">
        <AppSidebar fixed display="lg">
          <AppSidebarHeader >
          </AppSidebarHeader>
          <AppSidebarForm />
          <Suspense>
            <AppSidebarNav
              navConfig={lang_choiced.aside_menu}
              {...properties}
              router={router}
            ></AppSidebarNav>
          
          </Suspense>

          <AppSidebarFooter>
            <InstallButton />
          </AppSidebarFooter>
          <AppSidebarMinimizer></AppSidebarMinimizer>
        </AppSidebar>
        <main className="main">
          {
            // <AppBreadcrumb appRoutes={routes} router={router}/>
            /* Page code start */
          }
          <Container className="animated fadeIn" fluid>
            
            <Suspense fallback={loading()}>
              {props.children}
              <ContextMenuContainer />
            </Suspense>
          </Container>
        </main>
        {/* <AppAside fixed>
          <Suspense fallback={loading()}>
            <DefaultAside />
          </Suspense>
        </AppAside> */}
      </div>
      <AppFooter>
        <Suspense fallback={loading()}>
          <DefaultFooter />
             
        </Suspense>
      </AppFooter>
    </div>
  );
};

export default LayoutTest;
